import React from "react"
import { Navigate } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

import Dashboard from "../pages/Dashboard/index"

import CategoryIndex from "pages/Setting/Category"


// import Payment from "pages/Finance/Expense/Payment"
// import VendorPay from "pages/Finance/Expense/VendorPay"
// import BankAccount from "pages/Finance/BankAccount/BankAccount"
// import CreditCard from "pages/Finance/Credit Card/CreditCard"
// import GstIndex from "pages/Finance/GST/GstIndex"
// import TdsIndex from "pages/Finance/TDS/TdsIndex"
// import ZtplIndex from "pages/Finance/Performa Invoice/Ztpl/ZtplIndex"
// import AddPrfInvoice from "pages/Finance/Performa Invoice/Ztpl/AddPrfInvoice"
// import EditPrfInvoice from "pages/Finance/Performa Invoice/Ztpl/EditPrfInvoice"
// import ViewPrfInvoice from "pages/Finance/Performa Invoice/Ztpl/ViewPrfInvoice"
// import TsgIndex from "pages/Finance/Performa Invoice/TSG/TsgIndex"
// import AddTsgInvoice from "pages/Finance/Performa Invoice/TSG/AddTsgInvoice"
// import ViewTsgInvoice from "pages/Finance/Performa Invoice/TSG/ViewTsgInvoice"
// import EditTsgInvoice from "pages/Finance/Performa Invoice/TSG/EditTsgInvoice"
// import ZithasTechIndex from "pages/Finance/Invoice/Ztpl/ZithasTechIndex"
// import ViewZithasTechInvoice from "pages/Finance/Invoice/Ztpl/ViewZithasTechInvoice"
// import ZithasInvoiceIndex from "pages/Finance/Invoice/Zithas/ZithasInvoiceIndex"
// import ViewZithasInvoice from "pages/Finance/Invoice/Zithas/ViewZithasInvoice"
// import AddZithasInvoice from "pages/Finance/Invoice/Zithas/AddZithasInvoice"
// import EditZithasInvoice from "pages/Finance/Invoice/Zithas/EditZithasInvoice"
// import CloneZithasInvoice from "pages/Finance/Invoice/Zithas/CloneZithasInvoice"
// import StaffGuruIndex from "pages/Finance/Invoice/Staff Guru/StaffGuruIndex"
// import ViewStaffGuruInvoice from "pages/Finance/Invoice/Staff Guru/ViewStaffGuruInvoice"
// import ZithasPInvoiceIndex from "pages/Finance/Performa Invoice/Zithas/ZithasPInvoiceIndex"

import AccessDenied from "./AccessDenied"
import configure from "configure"
import CalenderIndex2 from "pages/Calender/CalenderIndex2"
import Crendential from "pages/Credentials/Crendential"
import Profile from "pages/Profile/Profile"


import KnowledgeBase from "pages/KnowledgeBase/KnowledgeBase"
// import EditTopic from "pages/KnowledgeBase/EditTopic/EditTopic"
// import AddTopic from "pages/KnowledgeBase/AddTopic/AddTopic"
// import ViewTopic from "pages/KnowledgeBase/ViewTopic/ViewTopic"
import VendorsPay from "pages/FinanceModule/Expence/VendorsPay"
import Expense from "pages/FinanceModule/Expence/Expense"
import BudgetExpense from "pages/FinanceModule/Expence/Budget"
import CrediCardSection from "pages/FinanceModule/Expence/CreditCardSection"

// Work -> General Settings 
import DragDashboard from "pages/Dashboard/DragDashboard"
import OverDraft from "pages/Finance/Expense/Overdraft/OverDraft"
import OverdraftIndex from "pages/Setting/Finance/Overdraft/OverdraftIndex"
import Ztpl from "pages/FinanceModule/Performa_Invoice_Section/Ztpl"
import ViewPerInvoice from "pages/FinanceModule/Performa_Invoice_Section/ViewPerInvoice"
import ZtplTaxInvoice from "pages/FinanceModule/Invoice/ZtplTaxInvoice"
import ViewZtplInvoice from "pages/FinanceModule/Invoice/ViewZtplInvoice"
import ZithasInvoice from "pages/FinanceModule/Invoice/ZithasInvoice"
import ZithasInvoiceView from "pages/FinanceModule/Invoice/ViewZithasInvoice"
import Inventory from "pages/FinanceModule/Inventory/Inventory"
// import InventoryIndex from "pages/Setting/Finance/Inventory/InventoryIndex"
import CalenderIndex3 from "pages/Calender/CalenderIndex3"
import HsnIndex from "pages/Setting/Finance/HsnIndex"
import InvoiceDetailIndex from "pages/Setting/Finance/Invoice"
import GstFinance from "pages/FinanceModule/GST/GstFinance"
import ZtplTdsPage from "pages/FinanceModule/TDS/ZtplTdsPage"
import ZithasTdsPage from "pages/FinanceModule/TDS/ZithasTdsPage"
import NotFound from "pages/WrongUrl/NotFound"
import FinanceReport from "pages/Reports/FinanceReport"
import CustomerStatement from "pages/FinanceModule/Reports/CustomerStatement"
import BankStatementConsole from "pages/FinanceModule/Reports/BankStatementConsole"
import CreditCardStatementConsole from "pages/FinanceModule/Reports/CreditCardStatementConsole"

const authProtectedRoutes = [
  {
    path: `${configure.appUrl}dashboard`,
    component: <DragDashboard />,
    // component: <Dashboard />,
  },
  {
    path: `${configure.appUrl}dashboard/drag_drop`,
    component: <Dashboard />,
    // component: <DragDashboard />,
  },
  {
    path: `${configure.appUrl}profile`,
    component: <Profile />,
  },

  // Expense
  {
    path: `${configure.appUrl}expense/budget-expense`,
    component: <BudgetExpense />,
    module_id: "41",
    type: "view",
  },
  {
    path: `${configure.appUrl}expense/expense`,
    component: <Expense />,
    module_id: "41",
    type: "view",
  },
  {
    path: `${configure.appUrl}expense/vendorspay`,
    component: <VendorsPay />,
    module_id: "41",
    type: "view",
  },
  {
    path: `${configure.appUrl}creditcard`,
    component: <CrediCardSection />,
    module_id: "43",
    type: "view",
  },

  // Invoice / Finance
  {
    path: `${configure.appUrl}performa_invoice/ztpl`,
    component: <Ztpl />,
    module_id: "44",
    type: "view",
  },
  {
    path: `${configure.appUrl}performa-invoice/view/:id`,
    component: <ViewPerInvoice />,
    module_id: "44",
    type: "view",
  },
  {
    path: `${configure.appUrl}invoice/ztpl_invoice`,
    component: <ZtplTaxInvoice />,
    module_id: "45",
    type: "view",
  },
  {
    path: `${configure.appUrl}finance/view-ztpl/:id`,
    component: <ViewZtplInvoice />,
    module_id: "45",
    type: "view",
  },
  {
    path: `${configure.appUrl}invoice/zithas_invoice`,
    component: <ZithasInvoice />,
    module_id: "45",
    type: "view",
  },
  {
    path: `${configure.appUrl}finance/view-zithas/:id`,
    component: <ZithasInvoiceView />,
    module_id: "45",
    type: "view",
  },


  {
    path: `${configure.appUrl}finance/inventory`,
    component: <Inventory />,
    module_id: "117",
    type: "view",
  },
  {
    path: `${configure.appUrl}finance/overdraft`,
    component: <OverDraft />,
    module_id: "103",
    type: "view",
  },

  {
    path: `${configure.appUrl}finance/finance-gst`,
    component: <GstFinance />,
    module_id: "46",
    type: "view",
  },

  // TDS
  {
    path: `${configure.appUrl}finance/tds/:tdsType`,
    component: <ZtplTdsPage />,
    module_id: "47",
    type: "view",
  },
  // {
  //   path: `${configure.appUrl}finance/zithas-tds`,
  //   component: <ZtplTdsPage />,
  //   // component: <ZithasTdsPage />,
  //   module_id: "47",
  //   type: "view",
  // },

  // Settings
  {
    path: `${configure.appUrl}setting/category`,
    component: <CategoryIndex />,
    module_id: "79",
    type: "view",
  },

  {
    path: `${configure.appUrl}setting/overdraft`,
    component: <OverdraftIndex />,
    module_id: "104",
    type: "view",
  },
  {
    path: `${configure.appUrl}setting/hsn`,
    component: <HsnIndex />,
  },
  {
    path: `${configure.appUrl}setting/invoice-details`,
    component: <InvoiceDetailIndex />,
    type: "view",
  },

  // Reports
  {
    path: `${configure.appUrl}reports/finance-report`,
    component: <FinanceReport />,
    module_id: "6",
    type: "view",
  },
  {
    path: `${configure.appUrl}reports/customer-statement`,
    component: <CustomerStatement />,
    module_id: "6",
    type: "view",
  },
  {
    path: `${configure.appUrl}reports/bank-statement-console`,
    component: <BankStatementConsole />,
    module_id: "6",
    type: "view",
  },
  {
    path: `${configure.appUrl}reports/credit-card-console`,
    component: <CreditCardStatementConsole />,
    module_id: "6",
    type: "view",
  },

  // Knowledge & Credentials
  {
    path: `${configure.appUrl}knowledgebase`,
    component: <KnowledgeBase />,
    module_id: "95",
    type: "view",
  },
  {
    path: `${configure.appUrl}credentials`,
    component: <Crendential />,
    module_id: "10",
    type: "view",
  },

  // Calendar
  {
    path: `${configure.appUrl}calendar`,
    component: <CalenderIndex2 />,
    module_id: "85",
    type: "view",
  },

  // Default redirect
  {
    path: `${configure.appUrl}`,
    exact: true,
    component: <Navigate to={`${configure.appUrl}dashboard`} />,
  },
];


const publicRoutes = [
  { path: `${configure.appUrl}logout`, component: <Logout /> },
  { path: `${configure.appUrl}login`, component: <Login /> },
  { path: `${configure.appUrl}forgot-password`, component: <ForgetPwd /> },
  { path: `${configure.appUrl}register`, component: <Register /> },
  { path: `${configure.appUrl}access-denied`, component: <AccessDenied /> },
  { path: `${configure.appUrl}not-found`, component: <NotFound /> },

  {
    path: `${configure.appUrl}calendar/:id`,
    component: <CalenderIndex3 />,
  },
  // {
  //   path: `${configure.appUrl}staff/Letters/:id`,
  //   component: <GenerateLinkLetters />
  // },
]

export { authProtectedRoutes, publicRoutes }
